/* React */
import React from "react";

/* Helper */
import getContentByName from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/content-container/getContentByName";

/* Interfaces */
interface ContentContainerProps {
  name: string;
}

const ContentContainer: React.FC<ContentContainerProps> = ({
  name,
}) => {
  return <div>{getContentByName(name)}</div>;
};

export default ContentContainer;
